import { type RichiestaDTO } from '@framework/api-client/api/inquiries-compile/schemas/richiestaDTO.ts';
import { getSorterOrdering } from '@framework/ui/core/pagination/getSorterOrdering.ts';
import { getPaginationUrlColumns } from '@framework/ui/core/pagination/paginationUrlColumns.ts';
import { type TableProps } from 'antd';
import { useCallback, useMemo } from 'react';
import { dossierSubmissionsColumns } from '../dossierSubmissionsColumns.tsx';

export interface IUseDossierSubmissionsTableOptions {
  ordering: string[] | undefined;
  setOrdering: (ordering: string[] | undefined) => void;
}

/**
 * Colonne e handler `onChange` della tabella (non paginata) delle richieste
 * della pratica: riflettono e aggiornano l'ordinamento.
 */
export function useDossierSubmissionsTable(
  options: IUseDossierSubmissionsTableOptions,
) {
  const { ordering, setOrdering } = options;

  // Colonne con l'ordinamento corrente evidenziato
  const columns = useMemo(
    () =>
      getPaginationUrlColumns(dossierSubmissionsColumns, {
        ordinamenti: ordering,
      }),
    [ordering],
  );

  // Senza paginazione `handlePaginationChange` imposterebbe `limite: 0`:
  // aggiorniamo solo l'ordinamento.
  const onTableChange = useCallback<
    NonNullable<TableProps<RichiestaDTO>['onChange']>
  >(
    (_pagination, _filters, sorter) => {
      setOrdering(getSorterOrdering(sorter));
    },
    [setOrdering],
  );

  return { columns, onTableChange };
}
